import type { NavSurface } from "@/components/ui/nav-surface/NavSurfaceContext";

/**
 * Language codes supported by the Eqqo translation provider for enterprise pages.
 * Sourced from the eqqo-react README — includes 33 source languages plus 7 target variants.
 */
export const EQQO_SUPPORTED_LANGUAGES = [
  "ar",
  "bg",
  "cs",
  "da",
  "de",
  "el",
  "en",
  "es",
  "et",
  "fi",
  "fr",
  "he",
  "hu",
  "id",
  "it",
  "ja",
  "ko",
  "lt",
  "lv",
  "nb",
  "nl",
  "pl",
  "pt",
  "ro",
  "ru",
  "sk",
  "sl",
  "sv",
  "th",
  "tr",
  "uk",
  "vi",
  "zh",
  "en-gb",
  "en-us",
  "es-419",
  "pt-br",
  "pt-pt",
  "zh-hans",
  "zh-hant",
];

/** How many active events org mode lists under "Active events". */
export const SIDEBAR_ACTIVE_EVENTS_LIMIT = 4;

/** Most event ids one sidebar summary request resolves. */
export const SIDEBAR_STAGES_MAX_EVENT_IDS = SIDEBAR_ACTIVE_EVENTS_LIMIT + 1;

/** How long a requested event summary counts as fresh before the sidebar asks again. */
export const SIDEBAR_STAGE_STALE_MS = 30_000;

/** Route Handler the sidebar reads event summaries from. */
export const SIDEBAR_STAGES_API_PATH = "/api/enterprise/sidebar-stages";

/** Focus ring every sidebar control shares: prod's inset 2px gray ring. */
export const SIDEBAR_FOCUS_CLASS =
  "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-gray-400/75";

/** Sidebar section label ("Event", "Organization"): prod's 12px medium label, in sentence case. */
export const SIDEBAR_SECTION_LABEL_CLASS = "whitespace-nowrap px-3 text-xs font-medium text-gray-600";

/** Sidebar section label on the admin rail: the same 12px medium label, muted, on the admin row's 10px inset. */
export const SIDEBAR_ADMIN_SECTION_LABEL_CLASS = "whitespace-nowrap px-2.5 text-xs font-medium text-muted-foreground";

/** Section label class for each nav surface, so a label reads the surface once and indexes here. */
export const SIDEBAR_SECTION_LABEL_CLASSES: Record<NavSurface, string> = {
  customer: SIDEBAR_SECTION_LABEL_CLASS,
  admin: SIDEBAR_ADMIN_SECTION_LABEL_CLASS,
};

/**
 * How long the sidebar stage card glows after a click on a next step the planner is already on,
 * so the click still shows it landed.
 */
export const STAGE_CARD_ACK_MS = 600;
